<template>
    <div class="sr-link-list">
        <SrLinkListGroup v-for="(group, index) in groups" :key="index" :group="group" />
    </div>
</template>

<script>
import SrLinkListGroup from './SrLinkListGroup';

export default {
    name: 'SrLinkList',
    components: { SrLinkListGroup },
    props: {
        groups: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
